import apiFetch from '../apiFetch'

export default function (token) {    
  return apiFetch({endPoint: `Pool/saveDataPoolPIC`, method: 'POST', token: token})
}
